import { InvestorDetailsSummaryTabHouseholdSummaryQuery } from '@/__generated__/graphql';
import NoResults from '@/components/table/noResults';
import { TableColumns } from '@/components/table/types';
import AllEntitiesSummaryTableRow from './tableRow';

interface AllEntitiesSummaryTableBodyProps {
  tableColumns: TableColumns[];
  tableRows: InvestorDetailsSummaryTabHouseholdSummaryQuery['investorHouseholdSummary']['data'];
  showSpecificColumns: boolean;
  expandedRows: Record<string, boolean>;
  setExpandedRows: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  handleEntitySelect: ({ entityId, isGroup }: { entityId: string; isGroup: boolean }) => void;
}

const AllEntitiesSummaryTableBody = ({
  tableColumns,
  tableRows,
  showSpecificColumns,
  expandedRows,
  setExpandedRows,
  handleEntitySelect
}: AllEntitiesSummaryTableBodyProps) => {
  const handleToggleRowExpanded = (rowId: string) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  if (!tableRows?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableRows.map((tableRow) => (
        <AllEntitiesSummaryTableRow
          key={tableRow.primaryLegalEntityId}
          tableColumns={tableColumns}
          tableRow={tableRow}
          showSpecificColumns={showSpecificColumns}
          isExpanded={expandedRows?.[tableRow.primaryLegalEntityId] ?? false}
          onToggleExpanded={() => handleToggleRowExpanded(tableRow.primaryLegalEntityId)}
          handleEntitySelect={handleEntitySelect}
        />
      ))}
    </>
  );
};

export default AllEntitiesSummaryTableBody;
